import {call, put, takeEvery, select} from 'redux-saga/effects';
import {Actions, ACTION_TYPES} from './types';
import CoursesService from '../../services/courses';
import courseActions from './actions';
import {selectLessonById} from './selectors';
import {TEST_STATE, Task} from '../../common/course';

//@ts-expect-error
const setTestState = result => {
    if (!result.state) {
        if (result.passed) {
            result.state = TEST_STATE.SUCCESS;
        } else {
            if (result.sealed && result.retryIn) {
                const {submissionDate} = result;
                if (!submissionDate) {
                    result.state = TEST_STATE.NOT_STARTED;
                } else {
                    if (result.retryIn <= 0) {
                        result.state = TEST_STATE.NOT_STARTED;
                    } else {
                        result.state = TEST_STATE.FAIL;
                    }
                }
            } else{
                result.state = TEST_STATE.NOT_STARTED;
            }
        }

    }
    return result;
};

export function* fetchCourses(action: Actions): Object {
    try {
        const result = yield call(
            CoursesService.getCourses.bind(CoursesService),
        );
        return yield put({
            type: ACTION_TYPES.LOAD_COURSES_SUCCESS,
            payload: result,
        });
    } catch (err) {
        console.log(err)
    }
    return null;
}

export function* fetchLessons(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            CoursesService.getCourseLessons.bind(CoursesService),
            String(payload),
        );
        return yield put({
            type: ACTION_TYPES.LOAD_LESSONS_SUCCESS,
            payload: result, 
        });
    } catch(err) {
        console.log(err)
    }
}

export function* fetchLesson(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            CoursesService.getLesson.bind(CoursesService),
            String(payload),
        );
        return yield put({
            type: ACTION_TYPES.LOAD_TASKS_SUCCESS,
            payload: result,
        });
    } catch(err) {
        console.log(err)
    }
}

export function* markTaskAsVisited(action: Actions): Object {
    const {payload} = action;
    try {
         yield call(
            //@ts-expect-error
            CoursesService.markTaskAsVisited.bind(CoursesService),
            payload,
        );
        //@ts-expect-error
        const lesson = yield select(selectLessonById, payload.lessonId);
        yield put(courseActions.fetchTasksByCourseId(lesson.courseId))
    } catch(err) {
        console.log(err)
    }
}


export function* fetchTasksByCourseId(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            CoursesService.getTasksByCourseId.bind(CoursesService),
            String(payload),
        );
       let tasks: Task[] = [];
       //@ts-expect-error
        const lessons = result.map(lesson => {
            const {tasks: tasksChunk, ...lessonResult} = lesson;
            tasks = [...tasks, ...tasksChunk];
            return lessonResult;
        })
        yield put({
            type: ACTION_TYPES.LOAD_LESSONS_SUCCESS,
            payload: lessons,
        })
        return yield put({
            type: ACTION_TYPES.LOAD_TASKS_SUCCESS,
            payload: tasks,
        });
    } catch(err) {
        console.log(err)
    }
}

export function* fetchTestById(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            //@ts-expect-error
            CoursesService.getTestById.bind(CoursesService),
            payload,
        );
        ;
        return yield put({
            type: ACTION_TYPES.LOAD_TEST_SUCCESS,
            payload: {
                ...setTestState(result),
                id: payload,
            },
        })
    } catch(err) {
        console.log(err)
    }
}

export function* sendTestResults(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            //@ts-expect-error
            CoursesService.sendTestResults.bind(CoursesService),
            payload,
        );
        setTestState(result); 
        return yield put({
            type: ACTION_TYPES.LOAD_TEST_LAST_SUBMITION_SUCCESS,
            payload: {
                ...result,
                //@ts-expect-error
                id: payload?.testId,
            },
        })
    } catch(err) {
        console.log(err)
    }
}

export function* getTestLastSubmition(action: Actions):Object {
    const {payload} = action;
    try {
        const result = yield call(
            //@ts-expect-error
            CoursesService.getTestLastSubmition.bind(CoursesService),
            payload,
        );
       
        return yield put({
            type: ACTION_TYPES.LOAD_TEST_LAST_SUBMITION_SUCCESS,
            payload: {
                ...setTestState(result),
                id: payload,
            },
        })
    } catch(err) {
        console.log(err);
    } 
}
const coursesSaga = [
    takeEvery(ACTION_TYPES.GET, fetchCourses),
    takeEvery(ACTION_TYPES.GET_LESSONS, fetchLessons),
    takeEvery(ACTION_TYPES.GET_TASKS, fetchLesson),
    takeEvery(ACTION_TYPES.MARK_TASK_AS_VISITED, markTaskAsVisited),
    takeEvery(ACTION_TYPES.GET_TASKS_BY_COURSE_ID, fetchTasksByCourseId),
    takeEvery(ACTION_TYPES.GET_TEST_BY_ID, fetchTestById),
    takeEvery(ACTION_TYPES.SEND_TEST_RESULTS, sendTestResults),
    takeEvery(ACTION_TYPES.GET_TEST_LAST_SUBMITION, getTestLastSubmition),
];

export default coursesSaga;
